import fileTypeToCustomValidationFunctionsDictionary from "components/Shared/MDropzone/utility/fileTypeToCustomValidationFunctionsDictionary";
import {filterValidFileTypesByType} from "components/Shared/MDropzone/utility";

const validateFile = async ({parsedAcceptedFile, validFileType, fileTypeCustomValidationFunctions}) => {

  const validationFunctionKeys = Object.keys(validFileType.options).filter(key => 
    fileTypeCustomValidationFunctions[key]
  );

  const rawErrors = await Promise.all(
    validationFunctionKeys.map(key => 
      fileTypeCustomValidationFunctions[key]({
        value: validFileType.options[key],
        parsedAcceptedFile
      })
    )
  );

  const errors = (rawErrors.map(rawError => 
    (Array.isArray(rawError) ? rawError : [rawError]).filter(subError => subError)
  ).filter(error => 
    error.length !== 0
  )).flat();

  return ({
    error: (errors && errors.length !== 0) && errors,
    file: parsedAcceptedFile,
  });
};

export default async ({parsedAcceptedFiles, validFileTypes}) => {
  if((Array.isArray(validFileTypes) ? validFileTypes.find(({options}) => options) : validFileTypes.options) === undefined)
    return ({
      validatedAcceptedFiles: parsedAcceptedFiles,
      errors: [],
    });
  const validatedFiles = await Promise.all(
    parsedAcceptedFiles.map(parsedAcceptedFile =>
      validateFile({
        parsedAcceptedFile,
        validFileType: filterValidFileTypesByType({validFileTypes, type: parsedAcceptedFile.type}),
        fileTypeCustomValidationFunctions: fileTypeToCustomValidationFunctionsDictionary[parsedAcceptedFile.type],
      })
    )
  );

  return validatedFiles.reduce(
    ({validatedAcceptedFiles, errors}, {error, file}) => error ? (
        {errors: [...errors, {error, file}], validatedAcceptedFiles}
    ) : (
        {validatedAcceptedFiles: [...validatedAcceptedFiles, file], errors}
    ),
    {validatedAcceptedFiles: [], errors: []}
  );
};
